<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-查询表单 -->
          <div class="md-layout card-form" style="max-width: 800px;">
            <!-- 表单-输入栏-查询参数 (与 searchType 对应) -->
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>ICCID</label>
                <md-input v-model="searchForm.searchValue"/>
              </md-field>
            </div>
            <!-- 表单-选择栏-设备状态 {0: 全部, 1: 移远, 2: 鼎兴} -->
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("type")}}</label>
                <md-select v-model="searchForm.state">
                  <md-option value="0">{{$I18n('all')}}</md-option>
                  <md-option v-for="item in $Param.iccType" :key="item.sort_num" :value="item.id">{{$I18n(item.name)}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-xsmall-size-50 left-layout-item">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="searchForm.comp_id">
                  <md-option  :value="0" >{{$I18n("all")}}</md-option>

                  <md-option v-for="comp in compData" :key  ="comp.comp_id" :value="comp.comp_id">
                    {{comp.comp_name}}
                  </md-option>
                </md-select>
                <!-- <md-icon v-if="error.company">clear</md-icon> -->
              </md-field>
            </div>
            <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
            <div class="md-layout-item md-size-25 left-layout-item" :style="{'padding-right':0}">
              <md-button class= "left-icon md-info " @click="form_changeSearchData">
                <md-icon>search</md-icon>{{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 表单-按钮- -->
          <div class="md-layout ">
            <div class="md-layout-item right-layout-item">
              <!-- 导出 -->
              <md-button class="left-icon md-info" @click="form_importModel">
                {{$I18n("import_and_update")}}
              </md-button>
              <!-- 记录 -->
              <md-button class="left-icon md-info" @click="form_importTableModel">
                {{$I18n("dev_import")}}
              </md-button>
            </div>
          </div>
          <!-- 卡片-主体-内容表格 
            体系
            所属企业
            UID
            MAC
            IP
            所属区域
            版本
            设备状态 {1: 未激活, 2: 已激活}
            首次激活时间
            最近上线时间
           -->
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="'ICCID'">{{ item.iccid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('net_type')">{{ item.net_type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref="modal" 
      :title="modalTitle" 
      :right="openModalType!=='delete'" 
      @submit="modal_submit" 
      :large="openModalType==='import'" 
      :submitBtn="openModalType !=='import'"
    >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 导入文件表格弹窗 -->
        <div v-if="openModalType==='import'">
          <!-- 弹窗-查询表单 -->
          <div class="md-layout">
            <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5: 正在导入}-->
            <div class="md-layout-item md-size-25 left-layout-item">
              <md-field>
                <label>{{$I18n("import_state")}}</label>
                <md-select v-model="modalSearchData.state" :placeholder="$I18n('pls_input_role_id')">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("has_sync_database")}}</md-option>
                  <md-option :value="2">{{$I18n("has_error_row")}}</md-option>
                  <md-option :value="3">{{$I18n("file_error")}}</md-option>
                  <md-option :value="4">{{$I18n("wait_sync_database")}}</md-option>
                  <md-option :value="5">{{$I18n("is_sync_database")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 时间选择-导入时间 -->
            <div class="md-layout-item md-size-30 left-layout-item">
              <md-field class="md-theme-default md-has-value">
                <label>{{$I18n("import_time")}}</label>
                <el-date-picker :picker-options="pickerOptions" :start-placeholder="$I18n('start')" :end-placeholder=" $I18n('end')" v-model="modalSearchData.time" class="md-date-form-item" align="left" type="daterange" range-separator="~" value-format="yyyy-MM-dd HH:mm:SS" />
              </md-field>
            </div>
            <!-- 按钮-提交查询 -->
            <div class="md-layout-item left-btn">
              <md-button class= "left-icon md-info" @click="modal_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
          <!-- 弹窗-表格
            ID
            用户ID
            企业名称
            体系
            文件下载链接
            文件处理数据数量详情
            状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入, 5:正在导入}
            导入时间
            完成时间
           -->
          <md-table :style="{'textAlign':'left !important'}" v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('import_id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.company }}</md-table-cell>
              <!-- <md-table-cell :md-label="$I18n('sys')">{{ item.sys }}</md-table-cell> -->
              <md-table-cell :md-label="$I18n('import_file')">
                <!-- 有下载地址 -->
                <a v-if="item.link_type === 1" :style='{color:"blue"}' :download="`import-${item.import_id}.xlsx`" :href="item.link_id">
                  {{`import-${item.id}.xlsx`}}
                </a>
                <!-- 没有下载链接 -->
                <span v-else>{{$I18n("is_none")}}</span>
              </md-table-cell>
              <!-- 显示样式 : 总数/成功条数(绿色)/失败条数(红色) -->
              <md-table-cell :md-label="`${$I18n('mng_num')}/${$I18n('succ_num')}/${$I18n('fail_num')}`">
                {{item.mng_num}}/
                <span :style='{color:"green"}'>{{item.succ_num}}</span>/
                <span :style='{color:"red"}'>{{item.fail_num}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_state')">
                <span v-if="item.state == 1" :style="{color:'green'}">
                  {{$I18n("has_sync_database")}}
                </span>
                <span v-else-if="item.state == 2" :style="{color:'red'}">
                  {{$I18n("has_error_row")}}
                </span>
                <span v-else-if="item.state == 3" :style="{color:'red'}">
                  {{$I18n("file_error")}}
                </span>
                <span v-else-if="item.state == 4" :style="{color:'red'}">
                  {{$I18n("wait_sync_database")}}
                </span>
                <span v-else-if="item.state == 5" :style="{color:'red'}">
                  {{$I18n("is_sync_database")}}
                </span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('import_date')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
        </div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field v-if="item.key ==='file'" :class="{'md-error' : modalData.Error.file}">
              <md-input v-model="modalData.Form.file" @click="modal_file_input" readonly :placeholder="$I18n('click_select_file')"/>
              <md-icon v-if="modalData.Error.file">clear</md-icon>
            </md-field>
          </common-form-item>
          <input :style="{display:'none'}" type="file" ref="inputFile" @change="onChange" />
        </div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template v-if="openModalType!=='import'" slot="footer-btn">
        <md-button :style="{ 'left': '32px', 'position': 'absolute',}" class="md-info" :download="`${$I18n('frame')}.xlsx`" href="/files/iccid.xlsx">
          {{$I18n("frame")}}
        </md-button>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString1000, FormClass } from "@/common/tools.js";

export default {
  data() {
    return {
      pickerOptions: { // 选择时间插件的配置 
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modalSearchData : { // 弹窗-表单-检索数据
        state : 0,
        time : [],
      },
      searchForm : { // 表单-表单数据
        searchValue: "",
        state : "0",
        comp_id: 0,
      },
      searchData : { // 表格-检索数据
        mac : "",
        uid : "",
        state: 0,
      },
      icon  : "computer", // ICON
      title : "ICCID", // 卡片标题
      tableInitData : [], // 表格数据
      compData : [], // 公司数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
      // 弹窗相关
      openModal: false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        company: this.UserInfo.comp_id ?this.UserInfo.comp_id :"",
        file : {
          init: "",
          check: (_ , formValue) => {
            return formValue.file_url === "";
          }
        },
        file_url : "",
      }),
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
    };
  },
  mounted : function() {
    this.api_getComp();
    this.api_getPageData();
  },
  watch: {
    import_currentPage(){
      this.api_getXlsxData();
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    modal_changeSearchData(){ // 弹窗-重新查询弹窗内表格数据
      this.api_getXlsxData();
    },
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click()
    },
    onChange ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      if(files[0].type.includes(".sheet")){
        this.modalData.Form.file = this.getFileName(files, target);
      } else {
        this.$errorMsg(this.$I18n("need_xlsx"))
      }
    },
    getFileName (files, target) { // 获取文件名
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.modalData.Form.file_url = ""
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData) // api: /open/file/upload
          .then(this.$Then(res => {
            this.modalData.Form.file_url = res.data;
          }))
          .catch(this.$Catch(this.$I18n("file_error"),() => {
            this.modalData.Form.file = ""
          }))
        return files[0].name
      }

      return null
    },
    api_getXlsxData (){ // API-提交xls文件数据
      this.$api.getImportIccInfo({
        ...this.modalTableForm,
        page_no  : this.import_currentPage,
        page_size: this.import_pageSize,
      }) 
        .then(this.$Then(resData => {
          this.modalTableInitData = resData.data;
          this.import_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableInitData = [];
          this.import_total = 0;
        }))
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getIccIdList({ // api: /mall/iccid/get
          ...this.searchData,
          page_size: this.pageSize,
          page_no: this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data.map(item => {
            if(!item.ver){
              item.ver = "";
            }
            return item;
          })
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    api_getComp (){ // API-获取公司信息
      //获取菜单
      this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("",() => {
          this.compData = [];
        }))
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        iccid  : this.searchForm.searchValue,
        type   : parseInt(this.searchForm.state),
        comp_id: parseInt(this.searchForm.comp_id),
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    form_importModel () { // 表单-打开 导入xlsx弹窗
      this.openModalType = "update";
      this.modalTitle = this.$I18n("import_and_update");
      if (this.compData.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalData.Reset();
      this.$refs.modal.open();
    },
    form_importTableModel () { // 表单-打开导入弹窗
      this.api_getXlsxData();
      this.openModalType = "import";
      this.modalTitle = this.$I18n("dev_import");
      this.$refs.modal.open();
    },
    modal_classicModalHide () { // 弹窗-隐藏 弹窗
      this.$refs.modal.close();
    },
    modal_submit () { // 弹窗-提交表单
      var compItem = this.compData.filter(comp => {
        return comp.comp_id == this.modalData.Form.company;
      })[0]
      if(!compItem){
        this.$errorMsg(this.$I18n("unknown_error"))
        return 
      }
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      this.$api.importIccId({ // api: /mall/iccid/import/add
          link_id: this.modalData.Form.file_url,
          comp_id: this.modalData.Form.company,
          link_type: 1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        state    : this.modalSearchData.state,
        gmt_start: this.modalSearchData.time && this.modalSearchData.time[0]?(new Date(this.modalSearchData.time[0]).getTime()/1000) :"",
        gmt_end  : this.modalSearchData.time && this.modalSearchData.time[1]?(new Date(this.modalSearchData.time[1].replace("00:00:00","23:59:59")).getTime()/1000) :"",
      }
    },
    modalTableData () { // 弹窗-表格-表格数据(处理后)
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .map(item => {
            // 公司
            let company  = this.$I18n("unknow");
            this.compData.forEach(function(com){
                if(com.comp_id == item.comp_id){
                  company = com.comp_short_name ?com.comp_short_name :com.comp_name;
                }
            })
            // 导入状态
            let import_state = this.$I18n("unknow");
            if(item.state== 1){
              import_state = this.$I18n("has_sync_database");
            }else if(item.state == 4){
              import_state = this.$I18n("wait_sync_database");
            }else if(item.state == 2 ){
              import_state = this.$I18n("has_error_row");
            } else if( item.state == 3){
              import_state = this.$I18n("file_error");
            } else if ( item.state == 5){
              import_state = this.$I18n("is_sync_database")
            }

            // 3个参数(确保是数字)
            item.mng_num =  isNaN(item.mng_num )  ?0 :item.mng_num ;
            item.succ_num = isNaN(item.succ_num ) ?0 :item.succ_num;
            item.fail_num = isNaN(item.fail_num ) ?0 :item.fail_num;

            let create_time = timestampToString1000(item.gmt_create);
            let update_time = timestampToString1000(item.gmt_update);
            return {
              create_time,
              update_time,
              company,
              import_state,
              ... item,
            }
          })
      }
    },
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {
          // 公司
          let company  = this.$I18n("unknow");
          this.compData.forEach(function(com){
              if(com.comp_id == item.comp_id){
                company = com.comp_short_name ?com.comp_short_name :com.comp_name;
              }
          })

          let type_name = this.$I18n(this.$Param.iccType.getName(item.type, "unknow"));
          let net_type_name = this.$I18n(this.$Param.netType.getName(item.network_type, "unknow"));

          let create_time = timestampToString1000(item.gmt_create);
          let update_time = timestampToString1000(item.gmt_update);
          return {
            type_name,
            net_type_name,
            create_time,
            update_time,
            company,
            ... item,
          }
        })
      }
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "company",
          type    : "select",
          options : this.compData.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          placeholder: this.$I18n('pls_select'),
        },{
          label   : this.$I18n("select_file"),
          isRequired: true,
          key     : "file",
        }
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
